import React, { useCallback, useState } from "react";
import { MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import { LinkOff as LinkOffIcon } from "@mui/icons-material";
import {
  BaseContextMenu,
  BaseContextMenuProps,
} from "../../../../components/datagrid/components/BaseContextMenu";
import { RemoveAsinsFromProduct } from "../../../../components/forms/CreateProductWizard/RemoveAsinsFromProduct";

const ProductContextMenu: React.FC<BaseContextMenuProps> = ({
  open,
  event,
  closeContextMenu,
  selectedRows,
  onGridRefresh,
  ...rest
}) => {
  const [activeModal, setActiveModal] = useState<string>("");

  const openContextModal = useCallback((modalName: string) => {
    setActiveModal(modalName);
  }, []);

  const closeModalAndRefresh = useCallback(() => {
    setActiveModal("");
    if (onGridRefresh) {
      onGridRefresh();
    }
    closeContextMenu();
  }, [onGridRefresh, closeContextMenu]);

  const handleMainMenuClose = useCallback(() => {
    setActiveModal("");
    closeContextMenu();
  }, [closeContextMenu]);

  // Resolve which custom modal to show (or null for none)
  let resolvedCustomModal: React.ReactNode | null = null;
  if (activeModal === "removeAsins" && selectedRows.length === 1) {
    const row = selectedRows[0];
    resolvedCustomModal = (
      <RemoveAsinsFromProduct
        productId={row.product.product_id}
        productTitle={row.product.product_title ?? ""}
        onClose={closeModalAndRefresh}
      />
    );
  }

  return (
    <BaseContextMenu
      open={open}
      event={event}
      closeContextMenu={handleMainMenuClose}
      selectedRows={selectedRows}
      onGridRefresh={onGridRefresh}
      activeCustomModal={resolvedCustomModal}
      {...rest}
    >
      <MenuItem
        disabled={selectedRows.length !== 1}
        onClick={() => openContextModal("removeAsins")}
      >
        <ListItemIcon>
          <LinkOffIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Remove ASINs from Product</ListItemText>
      </MenuItem>
    </BaseContextMenu>
  );
};

export default ProductContextMenu;
